// The Global Pole Inventory guide (58_PoleInventory.jsx · ModuleHelp, Max 01/11).
const en = {
  rangeT: 'Choose the months',
  rangeB: 'From and To set the months shown, twelve up to the one being closed by default. Refresh reloads the figures; Export gives you the working file in Excel.',
  tabsT: 'Seven tabs',
  tabsB: 'Summary, Month by frame family, Sales, Current position, Loads (uploads and closing a month), Mapping and Direct-sale buyers.',
  tilesT: 'The latest month at a glance',
  tilesB: 'Ending quantity and value, finished frames and loose poles for the last month shown, with the change from the month before.',
  tableT: 'Beginning, In, Out, Ending',
  tableB: 'Per entity, quantity and KRW for every month. A lock beside a month means it is closed. The gap line shows what the movement does not explain.',
};
const ko = {
  rangeT: '월 범위 선택',
  rangeB: 'From과 To로 보여줄 월을 정합니다. 기본은 마감 대상 월까지 12개월입니다. 새로고침은 수치를 다시 불러오고, Export는 작업 파일을 Excel로 내려받습니다.',
  tabsT: '일곱 개의 탭',
  tabsB: 'Summary, 프레임 계열별 Month, Sales, Current position, Loads(업로드와 월 마감), Mapping, Direct-sale buyers입니다.',
  tilesT: '최신 월 한눈에 보기',
  tilesB: '표시된 마지막 월의 기말 수량과 금액, 완제품 프레임과 폴 수량이며, 전월 대비 증감도 보여줍니다.',
  tableT: '기초, 입고, 출고, 기말',
  tableB: '법인별로 월마다 수량과 KRW를 보여줍니다. 월 옆의 자물쇠는 마감됐다는 뜻이고, 차이 행은 입출고로 설명되지 않는 금액입니다.',
};
const vi = {
  rangeT: 'Chọn khoảng tháng',
  rangeB: 'From và To đặt các tháng hiển thị, mặc định là mười hai tháng đến tháng đang chốt. Refresh tải lại số liệu; Export cho bạn file làm việc dạng Excel.',
  tabsT: 'Bảy tab',
  tabsB: 'Summary, Month theo họ khung, Sales, Current position, Loads (tải file lên và chốt tháng), Mapping và Direct-sale buyers.',
  tilesT: 'Tháng mới nhất trong một cái nhìn',
  tilesB: 'Số lượng và giá trị cuối kỳ, khung thành phẩm và pole rời của tháng cuối đang hiển thị, kèm chênh lệch so với tháng trước.',
  tableT: 'Đầu kỳ, Nhập, Xuất, Cuối kỳ',
  tableB: 'Theo từng entity, số lượng và KRW của mỗi tháng. Ổ khóa cạnh tháng nghĩa là tháng đã chốt. Dòng chênh lệch cho thấy phần biến động không giải thích được.',
};
const zh = {
  rangeT: '选择月份范围',
  rangeB: 'From 和 To 决定显示的月份，默认是截至当前结账月的十二个月。Refresh 重新加载数据；Export 导出 Excel 工作文件。',
  tabsT: '七个标签页',
  tabsB: 'Summary、按框架系列的 Month、Sales、Current position、Loads（上传与月结）、Mapping 和 Direct-sale buyers。',
  tilesT: '一眼看最新月份',
  tilesB: '显示的最后一个月的期末数量和金额、成品框架与单独 pole 的数量，并附上与上月的变化。',
  tableT: '期初、入库、出库、期末',
  tableB: '按实体列出每月的数量和 KRW。月份旁的锁表示该月已结账。差异行显示进出无法解释的部分。',
};
const dictionary = { ns: 'tourPole', en, ko, vi, zh };
export default dictionary;
